import { render, staticRenderFns } from "./KCTestZip.vue?vue&type=template&id=68f2c1ea&"
import script from "./KCTestZip.vue?vue&type=script&lang=js&"
export * from "./KCTestZip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports